import { lazy } from 'react';
import { WAREHOUSE_SERIES_CONTROL_SCREEN_KEY } from './screenKeys';

/**
 * Welcome to ScreenBuilderConfig
 * Max steps to implement new Action: 3
 */

/**
 * Step 1: Import new Screen Picker Icon
 */
import {
	ListIcon,
	StreamIcon,
	GridIcon,
	// <--HERE
} from 'components/Icons';

/**
 * Step 3: Add new authorized Screen key from <schema.feed_screens.key>
 */
const authorizedScreenKeys = {
	standardTableV1: 'standardTableV1',
	standardListV1: 'standardListV1',
	standardStreamV1: 'standardStreamV1',
	standardGridV1: 'standardGridV1',
	standardMapV1: 'standardMapV1',
	invReqTableV1: 'invReqTableV1',
	warehouseSeriesControlV1: WAREHOUSE_SERIES_CONTROL_SCREEN_KEY,
	// <--HERE
};

/**
 * Step 4: Add new screen picker icon
 */
const screenPickerIcons = {
	[authorizedScreenKeys.standardTableV1]: ListIcon,
	[authorizedScreenKeys.standardListV1]: ListIcon,
	[authorizedScreenKeys.standardStreamV1]: StreamIcon,
	[authorizedScreenKeys.standardGridV1]: GridIcon,
	[authorizedScreenKeys.standardMapV1]: GridIcon,
	[authorizedScreenKeys.invReqTableV1]: ListIcon,
	[authorizedScreenKeys.warehouseSeriesControlV1]: ListIcon,
};

/**
 * Step 5: Add new key:value pair screen
 */
const authorizedScreens = {
	[authorizedScreenKeys.standardTableV1]: lazy(
		() => import('./screens/StandardTableScreen/StandardTableScreen'),
	),
	[authorizedScreenKeys.standardListV1]: lazy(
		() => import('./screens/StandardListScreen'),
	),
	[authorizedScreenKeys.standardStreamV1]: lazy(
		() => import('./screens/StandardStreamScreen'),
	),
	[authorizedScreenKeys.standardGridV1]: lazy(
		() => import('./screens/StandardGridScreen'),
	),
	[authorizedScreenKeys.standardMapV1]: lazy(
		() => import('./screens/StandardMapScreen/StandardMapScreen'),
	),
	[authorizedScreenKeys.warehouseSeriesControlV1]: lazy(
		() =>
			import(
				'./screens/WarehouseSeriesControlScreen/WarehouseSeriesControlScreen'
			),
	),
	// <--HERE
};

class ScreenBuilderConfig {
	static authorizedScreenKeys() {
		return authorizedScreenKeys;
	}

	static getAuthorizedPickerIcons() {
		return screenPickerIcons;
	}

	/**
	 * @param {Object[]} screens - The module setted screens array from selected data filter item
	 * @returns Authorized screens to use in rest of code
	 */
	static getAuthorizedScreens(screens) {
		return screens.filter(
			screen => !!this.authorizedScreenKeys()[screen.key], // Call to gateway to access the authorized screen keys
		);
	}

	/**
	 * @param {Object[]} screenKey - The screen key from <feed_screens.key>
	 * @returns Authorized screen React Node
	 */
	static getAuthorizedScreenReactNode(screenKey) {
		return authorizedScreens[screenKey];
	}

	static getPickerIcon(screenKey) {
		return this.getAuthorizedPickerIcons()[screenKey];
	}

	static getSelectedScreen(selectedScreenId, authorizedScreens) {
		const selectedScreen = authorizedScreens.find(
			({ id }) => id === selectedScreenId,
		);
		return selectedScreen;
	}
}

export default ScreenBuilderConfig;
